import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../constants';
import { IsHelper } from './IsHelper';
import { UnwrapHelper } from './UnwrapHelper';
import { WrapHelper } from './WrapHelper';
export class UnwrapAssetHelper extends UnwrapHelper {
}
export class WrapAssetHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Asset;
    }
}
export class IsAssetHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Asset;
    }
}
export const hasAsset = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isAsset(context, node, tpe));
export const isOnlyAsset = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isAsset(context, node, tpe));
export const isAsset = (context, node, type) => context.builtins.isInterface(node, type, 'Asset');

//# sourceMappingURL=asset.js.map
